import React, {useEffect} from "react";
import Form from 'components/Form';
import {withRouter} from "react-router";
import {DemandValidationKeys} from 'constants/DemandValidation';
import ValidationShema from "constants/ValidationShema";
import PapersGeneratorService from "services/PapersGeneratorService";
import PapersGeneratorList from "components/complex/papersGenerator/PapersGeneratorList";

function PreparingPapersGenerator(
    {
        match
    }) {
    const FORM_ID = DemandValidationKeys.PREPARING_PAPERS_GENERATOR;
    const id = match.params.id;

    useEffect(() => {
        PapersGeneratorService.getAvailablePapers(id);
        return () => {
            PapersGeneratorService.clearResources(PapersGeneratorService.PAPERS_GENERATOR_LIST_RESOURCE_ID);
        }
    }, [id])

    return (
        <Form
            initialValues={{}}
            validationSchema={ValidationShema.any()}
            id={FORM_ID}
        >{(formikProps) => (
            <PapersGeneratorList id={id}/>)}
        </Form>
    )
}

PreparingPapersGenerator.propTypes = {
}

export default withRouter(PreparingPapersGenerator);